//3rd Party Components
import React, { Fragment } from 'react';
import MetaTags from 'react-meta-tags';
import axios from 'axios';
import { AUcallout } from '@gov.au/callout';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

//Components
import Heading from '../components/CASA/Heading';
import Container from '../components/CASA/Container';
import CASASpinner from '../components/Portal/CASASpinner';

//Actions
import { getPortalUrl, getUserHomePage, urlSearchValue } from '../components/Portal/Utilities';
import { getAircraftTOOIndividual, FETCH_AIRCRAFTTOOINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AircraftTOOIndividualActions';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getAlertsIndividual, FETCH_ALERTSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AlertsIndividualActions';
import { getAlertsAircraft, FETCH_ALERTSAIRCRAFT_SUCCESS } from '../PortalStore/Actions/AlertsAircraftActions';
import { getUrlSelector, getSnippetSelector } from '../PortalStore/Selectors/EnvDataSelectors';

export const SingleAircraftIndPage = () => {
    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");

    let dispatch = useDispatch();

    let aircraft = JSON.parse(atob(decodeURIComponent(urlSearchValue('aircraft'))));

    let userdetails = useSelector(state => state.userdetails);
    let B2CSettings = useSelector(state => state.B2CSettings);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);
    let tooIndividual = useSelector(state => state.aircraftTOOIndividual);
    let alertsIndividual = useSelector(state => state.alertsIndividual);
    let alertsAircraft = useSelector(state => state.alertsAircraft);

    let userHomePage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));
    let urlAEM = useSelector(state => getUrlSelector(state, "Portal - AEM URL"));
    let urlSeller = useSelector(state => getUrlSelector(state, "Portal - AEM Acft Transfer of Ownership URL - Seller"));

    const snippetTOO = useSelector(state => getSnippetSelector(state, 'CASA - Manage aircraft TOO'));

    useEffect(() => {
        const webappurl = B2CSettings.items.webappurlPortalApi;
        const accessToken = B2CSettings.items.accesstokenPortal;

        setPageLoading(true);

        axios.all([
            dispatch(getAircraftTOOIndividual(webappurl, accessToken)),
            dispatch(getAlertsIndividual(webappurl, accessToken)),
            dispatch(getAlertsAircraft(webappurl, accessToken, aircraft.id)),
        ])
            .then(axios.spread((toores, alertsindres, alertsairres) => {
                if (toores.type === FETCH_AIRCRAFTTOOINDIVIDUAL_SUCCESS
                    && alertsindres.type === FETCH_ALERTSINDIVIDUAL_SUCCESS
                    && alertsairres.type === FETCH_ALERTSAIRCRAFT_SUCCESS
                ) {
                    setPageLoaded(true);
                    setPageLoading(false);
                }
                else {
                    setPageLoadedError(true);
                    setPageLoadedErrorMessage("SAI.1");
                    setPageLoading(false);
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: SAI.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function (error) {
                setPageLoadedError(true);
                setPageLoadedErrorMessage("SAI.2");
                setPageLoading(false);
                setPageLoaded(true);

                let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                let details = "Details: SAI.2";
                dispatch(addPageAlert({ level: "error", title: msg, message: details }));
            });

    }, []);

    let showItems = false;

    let items = [
        {
            link: getPortalUrl("/dashind", standalone, urlHome),
            text: 'myCASA'
        },
        {
            link: getPortalUrl("/manageaircraftind", standalone, "/forms"),
            text: 'Manage aircraft'
        },
        {
            text: 'Aircraft details'
        }
    ];

    showItems = true;

    let transferinProgress = false;

    if (tooIndividual?.items?.value) {
        for (let b = 0; b < tooIndividual.items.value.length; b++) {
            if (tooIndividual.items.value[b]["aircraft.casa_aircraftregistrationid"] === aircraft.id && tooIndividual.items.value[b]["sub.statecode"].Value === "0") {
                transferinProgress = true;
            }
        }
    }

    const loc = getPortalUrl("/dashind", standalone, urlHome);

    const navigateToAcftTOOForm = () => {
        //only the owner of the aircraft can initiate Transfer of Ownership
        //show error if alerts on owner or aircraft 

        var url = urlAEM + urlSeller;

        var crumbs = [
            {
                link: loc,
                text: 'myCASA'
            },
            {
                link: getPortalUrl("/manageaircraftind", standalone, "/forms"),
                text: 'Manage aircraft'
            },
            {
                link: getPortalUrl("/singleaircraftind", standalone, "/forms") + "&aircraft=" + urlSearchValue('aircraft'),
                text: 'Aircraft details'
            }
        ];

        var params = {
            'breadcrumbs': crumbs,
            'registrationId': aircraft.id,
            'submissionId': ''
        };

        if ((alertsIndividual.items?.value && alertsIndividual.items.value.length > 0) || (alertsAircraft.items?.value && alertsAircraft.items.value.length > 0)) {
            url = "/forms/activealert?from=ind&casaorgid=&acftid=" + aircraft.id + "&standalone=" + standalone;
            location.assign(url);
        }
        else {
            location.assign(url + "?params=" + encodeURIComponent(btoa(JSON.stringify(params))));
        }
    }

    if (!pageLoaded) {
        return (
            <Fragment>
                <MetaTags>
                    <title>Aircraft details</title>
                </MetaTags>

                <Container show={true}>

                    <CASASpinner message="Working. Please wait....." />

                </Container>

            </Fragment>
        )
    }
    else {
        return (
            <Fragment>
                <MetaTags>
                    <title>Aircraft details</title>
                </MetaTags>

                <Heading
                    id="inddronedetails"
                    text="Aircraft details"
                    breadcrumbs={items}
                    showcrumbs={showItems}
                    showback={true} />

                {!transferinProgress ?
                    <AUcallout
                        title=""
                        srOnlyTitle>
                        <h4>Please ensure these aircraft details are correct</h4>
                        <p>If the aircraft manufacturer, type, serial number or registration holder / registered operator have changed, <a href="https://www.casa.gov.au/aircraft/civil-aircraft-register/aircraft-registration">you must inform CASA of these changes</a>. If the aircraft should no longer be registered you must submit a <a href="https://www.casa.gov.au/aircraft/civil-aircraft-register/aircraft-registration">cancellation of aircraft registration</a>.</p>
                        <p>Please also ensure your <a href="/profiledetailsind">personal details</a> are up to date.</p>
                        <br />
                        <a className="au-btn au-btn--darker" onClick={navigateToAcftTOOForm}>Transfer ownership</a>
                        <br />
                    </AUcallout>
                    : null
                }

                <h2 className="au-display-md">VH-Mark</h2>
                {aircraft.vhmark}
                <h2 className="au-display-md">Category</h2>
                {aircraft.category}
                <h2 className="au-display-md">Manufacturer</h2>
                {aircraft.manufacturer}
                <h2 className="au-display-md">Model</h2>
                {aircraft.model}
                <h2 className="au-display-md">Year of manufacture</h2>
                {aircraft.yearOfManufacture}
                <h2 className="au-display-md">Serial number</h2>
                {aircraft.serialno}
                <h2 className="au-display-md">Number of engines</h2>
                {aircraft.numberOfEngines}

                {aircraft.partOwner ?
                    <h2 className="au-display-md">Registration holder (main owner)</h2>
                    :
                    <h2 className="au-display-md">Registration holder</h2>
                }
                {aircraft.mainOwner.fullname}
                <br />
                {aircraft.mainOwner.postalAddress}
                <br />
                {aircraft.mainOwner.phone !== "" ?
                    <Fragment>
                        {aircraft.mainOwner.phone}
                        <br />
                    </Fragment>
                    : null
                }
                {aircraft.mainOwner.email}

                {aircraft.partOwner ?
                    <Fragment>
                        <h2 className="au-display-md">Registration holder (part owner)</h2>
                        {aircraft.partOwner.fullname}
                        <br />
                        {aircraft.partOwner.postalAddress}
                        <br />
                        {aircraft.partOwner.phone !== "" ?
                            <Fragment>
                                {aircraft.partOwner.phone}
                                <br />
                            </Fragment>
                            : null
                        }
                        {aircraft.partOwner.email}
                    </Fragment>
                    : null
                }

                <h2 className="au-display-md">Registration holder commencement date</h2>
                {aircraft.mainOwner.commencementDate}

                <h2 className="au-display-md">Aircraft first registered in Australia</h2>
                {aircraft.initially}

                <h2 className="au-display-md">Registered Operator</h2>
                {aircraft.mainOperator.fullname}
                <br />
                {aircraft.mainOperator.postalAddress}
                <br />
                {aircraft.mainOperator.phone !== "" ?
                    <Fragment>
                        {aircraft.mainOperator.phone}
                        <br />
                    </Fragment>
                    : null
                }
                {aircraft.mainOperator.email}

                <h2 className="au-display-md">Registered operator commencement date</h2>
                {aircraft.mainOperator.commencementDate}

                {transferinProgress ?
                    <AUcallout title="">
                        <div dangerouslySetInnerHTML={{ __html: snippetTOO }}></div>
                    </AUcallout>
                    : null
                }

                <div className="au-form-group" >
                    <a className="au-direction-link" href={loc}>
                        <span className="au-direction-link__arrow au-direction-link__arrow--left" />
                        Return to myCASA
                    </a>
                </div>

            </Fragment>
        );
    }
}
